import _typeof from "@babel/runtime/helpers/esm/typeof";
export default function isTouchDevice() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && ( // @ts-ignore
  'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}